import React from "react";
import "./suroundingarea.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import kawasanimages from "./suroundingarea.js";
import mapsimage from "../../media/maps.jpeg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";

const suroundingarea = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div id="surrounding" className="container-surounding">
      <div className="judul-surounding">SUROUNDING AREA</div>
      <div className="card-surounding">
        <div className="kartu">
          <Slider {...settings}>
            {kawasanimages.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Astha ${index + 1}`}
              />
            ))}
          </Slider>
        </div>
      </div>
      <div className="maps-lokasi">
        <img id="lokasi" className="img-lokasi" src={mapsimage} alt="maps" />
        <div className="lokasi-list">
          <h1>Lokasi</h1>
          <div className="list-lokasi">
            <FontAwesomeIcon icon={faLocationDot} />
            <span style={{ color: "white" }}>
              &nbsp;&nbsp;5 Menit ke Summarecon Mall Bekasi
            </span>
          </div>
          <div className="list-lokasi">
            <FontAwesomeIcon icon={faLocationDot} />
            <span style={{ color: "white" }}>
              &nbsp;&nbsp;10 Menit ke akses toll Bekasi Barat dan Marga Jaya 2
            </span>
          </div>
          <div className="list-lokasi">
            <FontAwesomeIcon icon={faLocationDot} />
            <span style={{ color: "white" }}>
              &nbsp;&nbsp;5 Menit ke CBD Bekasi
            </span>
          </div>
          <div className="list-lokasi">
            <FontAwesomeIcon icon={faLocationDot} />
            <span style={{ color: "white" }}>
              &nbsp;&nbsp;5 Menit ke sekolah Penabur dan al-Azhar
            </span>
          </div>
          <div className="list-lokasi">
            <FontAwesomeIcon icon={faLocationDot} />
            <span style={{ color: "white" }}>
              &nbsp;&nbsp;5 Menit ke Binus University
            </span>
          </div>
          <div className="list-lokasi">
            <FontAwesomeIcon icon={faLocationDot} />
            <span style={{ color: "white" }}>
              &nbsp;&nbsp;8 Menit ke pasar modern Sinpasa
            </span>
          </div>
          <div className="list-lokasi">
            <FontAwesomeIcon icon={faLocationDot} />
            <span style={{ color: "white" }}>
              &nbsp;&nbsp;10 Menit ke Mitra Keluarga Bekasi
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default suroundingarea;
